<template>
  <div :class="editable ? 'modal-card' : ''">
    <header v-if="editable" class="modal-card-head">
      <p class="modal-card-title">
        {{ $t("conditions") }}
      </p>
      <slot />
    </header>
    <form class="modal-card-body">
      <p class="subtitle">
        {{ $t("conditionsSettingsExplained") }}
      </p>
      <b-field :label="$t('currency')">
        <p>{{ $t("currencyExplained") }}</p>
      </b-field>
      <CurrencyPicker v-model="conditions.currency" :editable="editable" :platform="true" />
      <b-field :label="$t('perLangCombPerHour')">
        <p>{{ $t("perLangCombPerHourExplained") }}</p>
      </b-field>
      <b-field>
        <b-input v-model="conditions.perLangCombPerHour" type="number" :step="stepsize" :readonly="!editable" />
        <p class="control">
          <b-button class="is-static">
            {{ currencySymbol }}
          </b-button>
        </p>
      </b-field>

      <b-field :label="$t('minHours')">
        <p>{{ $t("minHoursExplained") }}</p>
      </b-field>
      <b-field>
        <b-input v-model="conditions.minHours" type="number" step="0.5" :readonly="!editable" />
        <p class="control">
          <b-button class="is-static"> h </b-button>
        </p>
      </b-field>

      <b-field :label="$t('perAudioParticipantPerHalfADay')">
        <p>{{ $t("perAudioParticipantPerHalfADayExplained") }}</p>
      </b-field>
      <b-field>
        <b-input
          v-model="conditions.perAudioParticipantPerHalfADay"
          type="number"
          :step="stepsize"
          :readonly="!editable"
        />
        <p class="control">
          <b-button class="is-static">
            {{ currencySymbol }}
          </b-button>
        </p>
      </b-field>

      <b-field :label="$t('perAudioParticipantPerDay')">
        <p>{{ $t("perAudioParticipantPerDayExplained") }}</p>
      </b-field>
      <b-field>
        <b-input v-model="conditions.perAudioParticipantPerDay" type="number" :step="stepsize" :readonly="!editable" />
        <p class="control">
          <b-button class="is-static">
            {{ currencySymbol }}
          </b-button>
        </p>
      </b-field>

      <b-field :label="$t('perVideoParticipantPerHalfADay')">
        <p>{{ $t("perVideoParticipantPerHalfADayExplained") }}</p>
      </b-field>
      <b-field>
        <b-input
          v-model="conditions.perVideoParticipantPerHalfADay"
          type="number"
          :step="stepsize"
          :readonly="!editable"
        />
        <p class="control">
          <b-button class="is-static">
            {{ currencySymbol }}
          </b-button>
        </p>
      </b-field>

      <b-field :label="$t('perVideoParticipantPerDay')">
        <p>{{ $t("perVideoParticipantPerDayExplained") }}</p>
      </b-field>
      <b-field>
        <b-input v-model="conditions.perVideoParticipantPerDay" type="number" :step="stepsize" :readonly="!editable" />
        <p class="control">
          <b-button class="is-static">
            {{ currencySymbol }}
          </b-button>
        </p>
      </b-field>

      <b-field>
        <b-input v-model="conditions.techSupportPerHour" type="number" :step="stepsize" :readonly="!editable" />
        <p class="control">
          <b-button class="is-static">
            {{ currencySymbol }}
          </b-button>
        </p>
      </b-field>

      <!--
      <b-field
        :label="$t('videoCostFromXUsers')"
      >
        <p>{{ $t('videoCostFromXUsersExplained') }}</p>
      </b-field>
      <b-field
        v-for="(videoCost, key) in conditions.videoCostFromXUsers"
        :key="key"
      >
        <b-tooltip 
          class="control is-info is-right"
          :label="key + ' ' + $t('orMore') + ' ' + $t('participants')"
        >
          <b-button
            class="is-info"
            :label="key + '+'"
          />
        </b-tooltip>
        <b-input
          v-model="conditions.videoCostFromXUsers[key]"
          type="number"
          :step="stepsize"
          :readonly="!editable"
        />
        
        <p class="control">
          <b-button class="is-static">
            {{ currencySymbol }}
          </b-button>
        </p>
        <div
          v-if="editable" 
          class="control"
        >
          <b-button 
            icon-left="delete"
            class="is-danger"
            @click="removeVideoCosts(key)"
          />
        </div>  
      </b-field>

      <b-field 
        v-if="editable"
        :label="$t('addCondition')"
      >
        <p>{{ $t('addConditionExplained') }}</p>
      </b-field>
      <b-field v-if="editable"> 
        <b-input
          v-model="addSelected"
          list="numberOfUsers"
        />
        <datalist id="numberOfUsers">
          <option 
            v-for="i in 9"
            :key="i"
          >
            {{ i+1 }}
          </option>
        </datalist>
        <div class="control">
          <b-button
            @click="addVideoCosts"
          >
            {{ $t('addCondition') }}
          </b-button>
        </div>
      </b-field>
      -->
    </form>
    <footer v-if="editable" class="modal-card-foot">
      <b-button type="is-primary" icon-left="content-save-outline" :loading="isLoading" @click="saveConditions">
        {{ $t("saveSettings") }}
      </b-button>
      <b-button class="is-info" @click="$parent.close()">
        {{ $t("close") }}
      </b-button>
    </footer>
  </div>
</template>

<script>
import { db } from "@/firebase";
import CurrencyPicker from "@/components/CurrencyPicker";

export default {
  name: "ConditionsSettingsModal",
  components: {
    CurrencyPicker,
  },
  props: {
    organizationId: {
      type: String,
      default: "",
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      exchangeRates: {
        EUR: 1.0,
        USD: 1.11,
        JPY: 133.0,
        CNY: 7.1,
        GBP: 0.85,
        SAR: 5.0,
        AED: 4.5,
        ARS: 100.0,
        BRL: 5.8,
        DKK: 7.45,
        HKD: 8.6,
        INR: 85.0,
        ILS: 3.7,
        KWD: 0.4,
        CHF: 1.05,
        SEK: 10.88,
        RUB: 120.0,
        NOK: 10.2,
        CAD: 1.45,
        AUD: 1.6,
      },
      settings: {
        conditions: {
          currency: "",
          perLangCombPerHour: 0.0,
          minHours: 0,
          perAudioParticipantPerDay: 1.0,
          perAudioParticipantPerHalfADay: 1.0,
          perVideoParticipantPerDay: 1.0,
          perVideoParticipantPerHalfADay: 1.0,
          techSupportPerHour: 80,
        },
      },
      isLoading: false,
      addSelected: null,
      oldCurrency: "",
    };
  },
  computed: {
    stepsize() {
      if (this.currency == "JPY") {
        return 1;
      }
      return 0.01;
    },
    currency() {
      return this.conditions.currency;
    },
    currencySymbol() {
      try {
        if (this.conditions.currency == "JPY") {
          return "¥";
        }
        return new Intl.NumberFormat("de-DE", {
          style: "currency",
          currency: this.conditions.currency,
        })
          .format(0)
          .substring(5);
      } catch (_error) {
        return "";
      }
    },
    conditions: {
      get() {
        return this.settings.conditions;
      },
      set(obj) {
        this.settings = obj;
      },
    },
  },
  watch: {
    currency: {
      immediate: true,
      handler(currency) {
        if (this.oldCurrency == "") {
          this.oldCurrency = currency;
          return;
        }
        if (currency != this.oldCurrency) {
          const currencyConstant = this.exchangeRates[currency] / this.exchangeRates[this.oldCurrency];
          this.oldCurrency = currency;
          this.conditions.perLangCombPerHour = Math.round(this.conditions.perLangCombPerHour * currencyConstant, 3);
          this.conditions.perAudioParticipantPerDay = Math.round(
            this.conditions.perAudioParticipantPerDay * currencyConstant,
            3,
          );
          this.conditions.perAudioParticipantPerHalfADay = Math.round(
            this.conditions.perAudioParticipantPerHalfADay * currencyConstant,
            3,
          );
          this.conditions.perVideoParticipantPerDay = Math.round(
            this.conditions.perVideoParticipantPerDay * currencyConstant,
            3,
          );
          this.conditions.perVideoParticipantPerHalfADay = Math.round(
            this.conditions.perVideoParticipantPerHalfADay * currencyConstant,
            3,
          );
          this.conditions.techSupportPerHour = Math.round(this.conditions.techSupportPerHour * currencyConstant, 3);
        }
      },
    },
    organizationId: {
      immediate: true,
      handler(organizationId) {
        this.$bind("settings", db.collection("organizations").doc(organizationId));
        /**
         * this reset of the object prevents ugly glitches & error as this.conditions gets momentarily undefined when rebound
         */
        this.conditions = {
          conditions: {
            currency: "",
            perLangCombPerHour: 0.0,
            minHours: 0,
            perAudioParticipantPerDay: 1.0,
            perAudioParticipantPerHalfADay: 1.0,
            perVideoParticipantPerDay: 1.0,
            perVideoParticipantPerHalfADay: 1.0,
            techSupportPerHour: 80,
          },
        };
      },
    },
  },
  methods: {
    saveConditions() {
      this.$buefy.dialog.confirm({
        title: this.$t("saveChanges"),
        message: this.$t("changeInfoInfo"),
        confirmText: this.$t("saveChanges"),
        cancelText: this.$t("cancel"),
        type: "is-info",
        closeOnConfirm: true,
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          await this.asyncSaveConditions();
          this.isLoading = false;
        },
      });
    },
    async asyncSaveConditions() {
      /**
       * @todo check if everything is correct
       */

      this.conditions.perAudioParticipantPerDay = parseFloat(this.conditions.perAudioParticipantPerDay);
      this.conditions.perAudioParticipantPerHalfADay = parseFloat(this.conditions.perAudioParticipantPerHalfADay);

      this.conditions.perVideoParticipantPerDay = parseFloat(this.conditions.perVideoParticipantPerDay);
      this.conditions.perVideoParticipantPerHalfADay = parseFloat(this.conditions.perVideoParticipantPerHalfADay);

      this.conditions.perLangCombPerHour = parseFloat(this.conditions.perLangCombPerHour);

      this.conditions.minHours = parseFloat(this.conditions.minHours);
      this.conditions.techSupportPerHour = parseFloat(this.conditions.techSupportPerHour);
      /*
      this.conditions.videoCostFromXUsers.map(videoCost => {
        console.log(videoCost)
      })
      */

      try {
        await db.collection("organizations").doc(this.organizationId).update({ conditions: this.conditions });
        this.$parent.close();
        this.$buefy.toast.open({
          type: "is-success",
          message: this.$t("settingsSaved"),
        });
      } catch (error) {
        this.$buefy.toast.open({
          type: "is-danger",
          message: error.toString(),
        });
      }
    },
    addVideoCosts() {
      if (this.addSelected === null) {
        return;
      }
      if (this.conditions.videoCostFromXUsers === undefined) {
        this.$set(this.conditions, "videoCostFromXUsers", {});
      }
      this.$set(this.conditions.videoCostFromXUsers, this.addSelected, 0);
    },
    removeVideoCosts(key) {
      this.$delete(this.conditions.videoCostFromXUsers, key);
    },
  },
};
</script>

<style></style>
